<template>
  <div class="panel-block account-list">
    <span class="panel-icon">
      <div class="animated-background placeholder-gravatar" />
    </span>
    <span class="placeholder-text animated-background" />
  </div>
</template>

<script>
export default {
  name: 'AccountPlaceholder'
}
</script>

<style lang="scss" scoped>

.placeholder-gravatar {
  width: 28px;
  height: 28px;
  border-radius: 14px;
}

.placeholder-text {
  width: 160px;
  height: 15px;
}

.animated-background {
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #f6f7f8;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px 104px;
  position: relative;
}

.account-list {
  padding: 6px 15px 6px 15px;
  border-left: none;
  border-right: none;
  height: 66px;

  .panel-icon {
    padding: 6px 30px 34px 0px;
  }
}
</style>
